import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from '@/pages/home/components/HeroBanner';
import CategoryNav from '@/pages/home/components/CategoryNav';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import VideoGrid from '@/pages/home/components/VideoGrid';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = '九九免费视频-海量高清资源免费看';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <FeaturedSection />
        <VideoGrid
          title="最新电影"
          subtitle="热门大片，第一时间上线"
          filter="dianying"
          limit={5}
        />
        <VideoGrid
          title="热门电视剧"
          subtitle="追剧不停，精彩不断"
          filter="dianshiju"
          limit={5}
        />
        <VideoGrid
          title="热门综艺"
          subtitle="欢笑不断，轻松一刻"
          filter="zongyi"
          limit={5}
        />
        <VideoGrid
          title="精品纪录片"
          subtitle="探索世界，发现真相"
          filter="jilupian"
          limit={5}
        />
        <VideoGrid
          title="人气动漫"
          subtitle="热血青春，二次元世界"
          filter="dongman"
          limit={5}
        />
      </main>
      <Footer />
    </>
  );
}